import React from 'react';
import PropTypes from 'prop-types';
import { toast as toastify } from 'react-toastify';

export function Toast({ title, type, ...props }) {
  return (
    <div {...props} className={`toast_container_wrapper ${type}`}>
      {title && <p className="title" dangerouslySetInnerHTML={{ __html: title }} />}
    </div>
  );
}

Toast.propTypes = {
  title: PropTypes.string,
  type: PropTypes.oneOf(['success', 'info', 'error']),
};

Toast.defaultProps = {
  title: '',
  type: 'success',
};

function toast({ title, type = 'success', ...props }, options = { autoClose: 3000 }) {
  return toastify(<Toast title={title} type={type} {...props} />, options);
}

toast.info = (content, options) => toast({ ...content, type: 'info' }, options);
toast.error = (content, options) => toast({ ...content, type: 'error' }, options);
toast.success = (content, options) => toast({ ...content, type: 'success' }, options);
toast.update = toastify.update;

export default toast;
